import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["combinedFields", "splitFields", "combinedSelect", "firstNameSelect", "lastNameSelect", "mode", "toggleLabel"]

  connect() {
    // Auto-detect mode based on pre-selected values
    const firstName = this.firstNameSelectTarget.value
    const lastName = this.lastNameSelectTarget.value

    if (firstName && lastName && firstName !== lastName) {
      this.modeTarget.value = "split"
      this.showSplit()
    } else {
      this.modeTarget.value = "combined"
      this.showCombined()
      // Sync combined select from first_name if set
      if (firstName) {
        this.combinedSelectTarget.value = firstName
      }
    }
  }

  toggle() {
    if (this.modeTarget.value === "combined") {
      this.modeTarget.value = "split"
      this.showSplit()
    } else {
      this.modeTarget.value = "combined"
      this.showCombined()
    }
  }

  syncFromCombined() {
    const value = this.combinedSelectTarget.value
    this.firstNameSelectTarget.value = value
    this.lastNameSelectTarget.value = value
  }

  showCombined() {
    this.combinedFieldsTarget.classList.remove("hidden")
    this.splitFieldsTarget.classList.add("hidden")
    if (this.hasToggleLabelTarget) this.toggleLabelTarget.textContent = "I have separate first/last columns"
    this.syncFromCombined()
  }

  showSplit() {
    this.combinedFieldsTarget.classList.add("hidden")
    this.splitFieldsTarget.classList.remove("hidden")
    if (this.hasToggleLabelTarget) this.toggleLabelTarget.textContent = "I have a combined name column"
  }
}
